import { AxiosResponse } from 'axios';

import {
  ICreateEducationPriorityRequest,
  IEducationPriority,
  IUpdateEducationPriorityRequest,
} from './education-priority.interface';

import { axiosApiInstance } from 'services/config';

class EducationPriorityApi {
  async getAll(): Promise<IEducationPriority[]> {
    const response: AxiosResponse<IEducationPriority[]> = await axiosApiInstance.get(
      'education-priority',
    );
    return response.data;
  }

  async getByAccount(accountId: number): Promise<IEducationPriority[]> {
    const response: AxiosResponse<IEducationPriority[]> = await axiosApiInstance.get(
      `education-priority/account/${accountId}`,
    );
    return response.data;
  }

  async create(
    requestData: ICreateEducationPriorityRequest,
  ): Promise<IEducationPriority> {
    const response: AxiosResponse<IEducationPriority> = await axiosApiInstance.post(
      'education-priority',
      requestData,
    );
    return response.data;
  }

  async update(
    id: number,
    accountId: number,
    requestData: IUpdateEducationPriorityRequest,
  ): Promise<IEducationPriority> {
    const response: AxiosResponse<IEducationPriority> = await axiosApiInstance.put(
      `education-priority/${id}`,
      { ...requestData, accountId },
    );
    return response.data;
  }

  async remove(id: number): Promise<void> {
    await axiosApiInstance.delete(`education-priority/${id}`);
  }
}

export { EducationPriorityApi };
